var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content",staticStyle:{"margin":"0px","width":"100%"}},[_c('PageHeader',{directives:[{name:"show",rawName:"v-show",value:(_vm.statusBreadcrumbs),expression:"statusBreadcrumbs"}]}),(_vm.$route.name === _vm.names.BASE)?_c('Main',{attrs:{"name_list":_vm.left_menu_list}}):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }